import wrapWithProvider from "./src/state/wrapWithProvider";
import "./src/styles/global.scss"

export const wrapRootElement = wrapWithProvider;
